// extracted by mini-css-extract-plugin
module.exports = {"modal__overlay":"dfModal_modal__overlay__1kFzF","modal__close":"dfModal_modal__close__1KkGM","form":"dfModal_form__3WkFZ"};